import z from "zod";

import { zSchema } from "../../../../entity";

const zIn = zSchema
  .omit({
    id: true,
  })
  .pick({
    email: true,
    phone: true,
    firstName: true,
    lastName: true,
    password: true,
  })
  .extend({
    roles: z.array(
      zSchema.shape.roles.element.pick({
        id: true,
      }),
    ),
  });
type In = z.infer<typeof zIn>;

export { zIn };
export type { In };
